type NemoJwtTokenClaims = {
  'mandant-id': string;
  application: string;
  'market-id': string;
  language: string;
  'image-render-policy': string;

  /**
   * Expiration time (seconds since Unix epoch)
   */
  exp: number;
};

export const parseJwtContent = (token: string): NemoJwtTokenClaims => {
  if (token) {
    const base64Url = token.split('.')[1];
    if (base64Url) {
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        window
          .atob(base64)
          .split('')
          .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join(''),
      );

      return JSON.parse(jsonPayload) as NemoJwtTokenClaims;
    }
  }
};
